var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{class:{ 'cursor-pointer': _vm.enableClick },on:{"click":_vm.onClick}},[_vm._t("default",null,{"active":_vm.active})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }